<template>
    <ul class="job-page__description">
        <PrismicRichText v-if="description" :field="description" />
        <li v-for="i in jobIndexes" v-else :key="i">
            <VJoyIcon name="arrow-right" />
            {{ t(`landing.acquisition.header.usp.${i}`, [landingPage?.textualContent.numberOfFreelancersRounded]) }}
        </li>
    </ul>
</template>

<script setup lang="ts">
    import {inject} from 'vue';
    import {PrismicRichText} from '@prismicio/vue';
    import {useTranslation} from '#imports';
    import {VJoyIcon} from '@maltjoy/core-vue';
    import {JOB_PAGE} from '~/keys';

    const {t} = useTranslation();

    const jobIndexes = [1, 2, 3] as const;

    const {landingPage, prismicTemplate, prismicPage, jobPageConfig} = inject(JOB_PAGE) || {};
    const description =
        jobPageConfig?.primary.heroDescription ||
        (prismicPage?.data.heroDescription.length ? prismicPage?.data.heroDescription : prismicTemplate?.data.heroDescription);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .job-page__description {
        list-style-type: none;
        max-width: 600px;
        font-weight: var(--joy-font-weight-normal);
        font-size: var(--joy-font-size-primary-400);

        @include mq.screen_md(min) {
            font-size: var(--joy-font-size-primary-600);
        }

        li {
            position: relative;
            display: flex;
            align-items: center;
            line-height: var(--joy-line-height-large);
            padding-left: var(--joy-core-spacing-8);
            margin-bottom: var(--joy-core-spacing-5);
        }

        .joy-icon {
            position: absolute;
            left: 0;

            @include mq.screen_md(min) {
                top: 4px;
            }
        }
    }
</style>
